export default __webpack_public_path__ + "static/media/Faturas (Real Size).1409bd65.svg";